var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-popover",
        { attrs: { placement: "top-end", width: "400", trigger: "click" } },
        [
          _c("picker", {
            attrs: { data: _vm.emojiIndex, showPreview: false },
            on: { select: _vm.addEmoji },
          }),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "mr-2",
              attrs: { slot: "reference" },
              slot: "reference",
            },
            [
              _c(
                "el-tooltip",
                { attrs: { content: "Emoji", placement: "top" } },
                [
                  _c("a", { attrs: { href: "#" } }, [
                    _c("i", { staticClass: "far fa-smile" }),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "placeholders-picker",
        { on: { select: _vm.addPlaceholder } },
        [
          _c(
            "el-tooltip",
            { attrs: { content: "Placeholders", placement: "top" } },
            [
              _c("a", { attrs: { href: "#" } }, [
                _c("i", { staticClass: "fas fa-code" }),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }